import type { Tone } from 'src/lib/tone';

type BadgeProps = {
  tone: Tone;
  children: React.ReactNode;
  /** Design System §5: the word is always present. A tone is never the only carrier of meaning. */
  title?: string;
};

/** Status only — never action, never importance (Design System §3.2). */
export function Badge({ tone, children, title }: BadgeProps) {
  return (
    <span className="badge" data-tone={tone} title={title}>
      {children}
    </span>
  );
}
